import React, { useEffect, useState } from "react";
import theme from "../../theme";
import { useDispatch, useSelector } from "react-redux";
import { getChartData } from '../../redux/slices/reportSlice';
import DateRangePickerComponent from "../common/DateRangePickerComponent";
import styled from "styled-components";
import {
  BarChart,
  Bar,
  XAxis,
  CartesianGrid,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { useMediaQuery } from '@mui/material';
import { format } from 'date-fns';
//import { format, parse } from 'date-fns';

// const formatDate = (dateString) => {
//   const parsedDate = parse(dateString, 'dd-MM-yy', new Date());
//   return format(parsedDate, 'MMM dd, yyyy');
// };

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;


const Barchart = () => {
  const dispatch = useDispatch();
  const { chartData } = useSelector((state) => state.report);
  const [dateRange, setDateRange] = useState({});

  useEffect(() => {
    dispatch(getChartData({}));
  }, [dispatch]);

  useEffect(() => {
    if (dateRange.startDate && dateRange.endDate) {
      const startDate = format(dateRange.startDate, 'yyyy-MM-dd');
      const endDate = format(dateRange.endDate, 'yyyy-MM-dd');
      dispatch(getChartData({ startDate, endDate }));
    }
  }, [dateRange, dispatch]);

  const formattedData = chartData.map(item => ({
    name: item.day,
    conversion: item.totalConversions,
  }));
  const formatCurrency = tick => {
    if (tick >= 1000000) return `${tick / 1000000}m`;
    if (tick >= 1000) return `${tick / 1000}k`;
    return tick;
  };

  const CustomConversionBar = props => {
    const { fill, x, y, height } = props;
    const radius = 3;
    const isTab = useMediaQuery('(max-width:867px)');
    const isMobile = useMediaQuery('(max-width:567px)');
    const barWidth = isMobile ? 15 : isTab ? 25 : 37;
    return (
      <rect
        x={x}
        y={y}
        width={barWidth}
        height={height}
        fill={fill}
        rx={radius}
        ry={radius}
      />
    );
  };

  return (
    <div>
      <Wrapper>
        <div></div>
        <DateRangePickerComponent onDateChange={setDateRange} />
      </Wrapper>
    <div style={{ marginLeft: '-30px', marginTop: '5px' }}>
      <ResponsiveContainer width={'100%'} height={300}>
        <BarChart data={formattedData}>
          <CartesianGrid vertical={false} stroke='#eee' />
          <YAxis
            stroke='#9C9C9C'
            fontSize={10}
            fontWeight={300}
            minTickGap={1}
            tickFormatter={formatCurrency}
            axisLine={false}
            tickLine={false}
          />
          <XAxis
            dataKey='name'
            stroke='#9C9C9C'
            fontSize={10}
            fontWeight={300}
            minTickGap={1}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip />
          <Legend verticalAlign='top' height={36} />
          <Bar
            type='monotone'
            dataKey='conversion'
            fill={theme.color.brand}
            stackId='a'
            shape={<CustomConversionBar />}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
    </div>
  );
};

export default Barchart;
